import { MessageList } from "../MessageList";
import { ChatInput } from "components/inputs/chatInput";

import { ActiveChatWrapper } from "./styles";
import { SuggestionsListScreen } from "../MessageList/components/SuggestionsListScreen";
import { ExportAnalyseContentDialog } from "../ExportAnalyseContentDialog";
import { useActiveChat } from "./useActiveChat";
import { LoadingScreen } from "components/screens/loadingScreen";
import { SeeMoreAccordion } from "../SeeMoreAccordion";
import { Stack } from "@mui/material";
import { EditGraph } from "pages/analyse/editGraph";
import { createContext } from "react";

export const ChatContext = createContext();

export const ActiveChat = () => {
  const activeChatProps = useActiveChat();

  const {
    onChange,
    handleKeyDown,
    handleSetExampleMessage,
    message,
    handleSubmit,
    sendMessage,
    messages,
    suggestionsLoading,
    suggestionsList,
    hasAnalysesInMessages,
    onCloseEditGraph,
    isEditGraphOpen,
    editGraphRoute,
    onAnalysisUpdate,
  } = activeChatProps || {};

  return (
    <>
      <ChatContext.Provider value={activeChatProps}>
        {isEditGraphOpen && (
          <EditGraph
            route={editGraphRoute}
            open={isEditGraphOpen}
            handleClose={onCloseEditGraph}
            successCallback={onAnalysisUpdate}
          />
        )}
        {suggestionsLoading ? (
          <LoadingScreen wrapperSx={{ height: "calc(100svh - 100px)" }} />
        ) : (
          <>
            <ExportAnalyseContentDialog />

            <ActiveChatWrapper>
              {!messages.length && !!Object.keys(suggestionsList)?.length && <SuggestionsListScreen />}

              {!!messages.length && <MessageList />}

              <Stack gap="10px">
                {hasAnalysesInMessages && <SeeMoreAccordion />}

                <ChatInput
                  label="what do you want to do..."
                  name="chat"
                  {...{
                    onChange,
                    handleKeyDown,
                    handleSetExampleMessage,
                    message,
                    handleSubmit,
                    hasSeeMore: hasAnalysesInMessages,
                    sendMessage,
                  }}
                />
              </Stack>
            </ActiveChatWrapper>
          </>
        )}
      </ChatContext.Provider>
    </>
  );
};
